export const TOUCH_MEDIA_QUERY = '(pointer: coarse)';
export const isTouchDevice = () => window.matchMedia(TOUCH_MEDIA_QUERY).matches;
